import { render, staticRenderFns } from "./stripepaymentsuccess.vue?vue&type=template&id=970fea4e&scoped=true"
import script from "./stripepaymentsuccess.vue?vue&type=script&lang=js"
export * from "./stripepaymentsuccess.vue?vue&type=script&lang=js"
import style0 from "./stripepaymentsuccess.vue?vue&type=style&index=0&id=970fea4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "970fea4e",
  null
  
)

export default component.exports